import React, { Component } from "react";
import VendedorActualizacionResumen from "../../../../types/VendedorActualizacionResumen";

interface Props {
  resumen: VendedorActualizacionResumen[];
}

export default class ReasignacionVendedorTable extends Component<Props> {
  getRowStyle = (resultado: "ERROR" | "WARNING" | "SUCCESS") => {
    switch (resultado) {
      case "ERROR":
        return { backgroundColor: "#f8d7da" };
      case "WARNING":
        return { backgroundColor: "#fffbdbff" };
      case "SUCCESS":
        return { backgroundColor: "#d4edda" };
      default:
        return {};
    }
  };

  getBadgeClass = (resultado: "ERROR" | "WARNING" | "SUCCESS") => {
    switch (resultado) {
      case "ERROR":
        return "text-danger";
      case "WARNING":
        return "text-warning";
      case "SUCCESS":
        return "text-success";
      default:
        return "text-secondary";
    }
  };

  getDescripcion = (resultado: "ERROR" | "WARNING" | "SUCCESS") => {
    switch (resultado) {
      case "ERROR":
        return "Error";
      case "WARNING":
        return "Advertencia";
      case "SUCCESS":
        return "Correcto";
      default:
        return "Advertencia";
    }
  };

  render() {
    const { resumen } = this.props;

    if (!resumen || resumen.length === 0) {
      return null;
    }

    const errores = resumen.filter(r => r.resultado === "ERROR").length;
    const warnings = resumen.filter(r => r.resultado === "WARNING").length;
    const exitosos = resumen.filter(r => r.resultado === "SUCCESS").length;

    return (
      <>
        <div className="mb-4">
          <div className="row">
            <div className="col-12">
              <p className="text-muted">
                Total de registros procesados: {resumen.length}
                {" - "}
                <span className="text-success">Exitosos: {exitosos}</span>
                {" - "}
                <span className="text-warning">Advertencias: {warnings}</span>
                {" - "}
                <span className="text-danger">Errores: {errores}</span>
              </p>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th>ID Cotización</th>
                      <th>Folio Factura</th>
                      <th>Vendedor Actual</th>
                      <th>Vendedor Nuevo</th>
                      <th>Descripción Venta</th>
                      <th>Estado</th>
                      <th>Mensaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumen.map((item, i) => (
                      <tr key={i} style={this.getRowStyle(item.resultado)}>
                        <td>
                          <small>{item.idCotizacionItem}</small>
                        </td>
                        <td>
                          <small>{item.folioFactura}</small>
                        </td>
                        <td>
                          <small>
                            ({item.actualNumeroEmpleado}) {item.actualEmpleado}
                          </small>
                        </td>
                        <td>
                          <small>
                            ({item.nuevoNumeroEmpleado}) {item.nuevoEmpleado}
                          </small>
                        </td>
                        <td>
                          <small>{item.ventaDescripcion}</small>
                        </td>
                        <td>
                          <span className={this.getBadgeClass(item.resultado)}>
                            {this.getDescripcion(item.resultado)}
                          </span>
                        </td>
                        <td>
                          <small>{item.mensaje}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
